module.exports = __webpack_public_path__ + "static/img/70.df70c09b.jpg";